var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_23037",
    "data-name": "Raggruppa 23037",
    transform: "translate(-1826 -325)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_23035",
    "data-name": "Raggruppa 23035",
    transform: "translate(100 62)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_11790",
    "data-name": "Rettangolo 11790",
    width: 25,
    height: 25,
    rx: 4,
    transform: "translate(1726 263)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-mail",
    "data-name": "Icon ionic-ios-mail",
    transform: "translate(1726.625 262.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_33434",
    "data-name": "Tracciato 33434",
    d: "M20.161,10.339,15.784,14.8a.079.079,0,0,0,0,.114l3.064,3.263a.528.528,0,0,1,0,.749.53.53,0,0,1-.749,0l-3.051-3.251a.083.083,0,0,0-.118,0l-.745.757a3.276,3.276,0,0,1-2.335.985A3.341,3.341,0,0,1,9.465,16.4l-.716-.728a.083.083,0,0,0-.118,0L5.58,18.923a.53.53,0,0,1-.749,0,.528.528,0,0,1,0-.749L7.9,14.912a.087.087,0,0,0,0-.114L3.513,10.339a.08.08,0,0,0-.138.057v8.922a1.306,1.306,0,0,0,1.3,1.3H19a1.306,1.306,0,0,0,1.3-1.3V10.4A.081.081,0,0,0,20.161,10.339Z",
    transform: "translate(0 -1.028)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_33435",
    "data-name": "Tracciato 33435",
    d: "M12.2,15.324a2.212,2.212,0,0,0,1.591-.667l6.383-6.5a1.279,1.279,0,0,0-.806-.285H5.031a1.27,1.27,0,0,0-.806.285l6.383,6.5A2.212,2.212,0,0,0,12.2,15.324Z",
    transform: "translate(-0.358)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationOpen);
export default __webpack_public_path__ + "static/media/notification-open.e88560dcf88aba0fdecc05c2adf93e91.svg";
export { ForwardRef as ReactComponent };